import React, { forwardRef, useMemo, useEffect, useState, Fragment, Suspense, lazy } from 'react';
import cn from 'classnames';
import SvgIcon from '../../../common/SvgIcon';
import { isZipValid } from '../utils/validation';
import FormInput from '../../../pro_platform_sign_up/components/FormInput';
// react-select is ~30% of the brief bundle and only shows after a postcode search, so it
// loads as its own chunk. The import starts when this step mounts, well before a search
// returns; Suspense covers the rare case it hasn't arrived yet.
const loadSelect = () => import("../../../common/components/Select/Select");
const Select = lazy(loadSelect);
// Same for the address lookup: it brings axios, and only this step needs it.
const loadAddressLookupApi = () => import("../../../design/api/address-lookup-api");
// import AutocompleteField from "../../../design/routes/Moodboard/components/AutocompleteField";

const BriefAddress = (
  { value, children, proPlatform, className, invalid, onChange, ...rest }, ref,
) => {

  useEffect(() => {
    loadSelect();
    loadAddressLookupApi();
  }, []);

  const [manualInput, setManualInput] = useState(false);
  const [addressList, setAddressList] = useState([]);
  const [addressSelected, setAddressSelected] = useState(null);
  const [addressSearchError, setAddressSearchError] = useState(false);

  const isDirty = useMemo(() => Object.values(value).some(v => !!(v || '').length), [value]);
  const focusAddress = () => {
    return { type: 'Focus Address', payload: { focused: true } };
  };

  const blurAddress = () => {
    return { type: 'blurAddress', payload: { focused: true } };
  };
  const scrollAddress = () => {
    return { type: 'scrollAddress', payload: { focused: true } };
  };
  const updateAddress = () => {
    return { type: 'scrollAddress', payload: { focused: true } };
  };

  const addressLabel = item => {
    const addressFields = [item.line_1, item.line_2, item.post_town];
    return addressFields.filter(str => Boolean(str)).join(', ');
  };

  const addressLabelNoTown = item => {
    const addressFields = [item.line_1, item.line_2];
    return addressFields.filter(str => Boolean(str)).join(', ');
  };

  const onAddressSelected = (address) => {
    setAddressSelected(address);
    const {
      raw,
      raw: {
        post_town,
        postcode
      }
    } = address;
    onChange({
      ...value,
      address: addressLabelNoTown(raw),
      town: post_town,
      postcode: postcode,
    });
  };
  const postcodeSearchSuccess = (result) => {
    const resultAddress = result.map(item => ({
      value: item.id,
      raw: item,
      label: addressLabel(item),
    }));
    setAddressList(resultAddress);
    setAddressSearchError(false);
  };
  const postcodeSearchFailed = (error) => {
    setAddressSearchError(true);
    // setAddressList([]);
    error;
  };
  const searchPostcode = () => {
    const { postcode } = value;
    loadAddressLookupApi().then(({ default: AddressLookupApi }) => {
      AddressLookupApi.addressByPostcode(
        postcode,
        postcodeSearchSuccess,
        postcodeSearchFailed,
      );
    }, postcodeSearchFailed);
  };

  return (
    <div ref={ref} className={cn('brief_step -address', className)} {...rest} >

      <div className="brief_step-title-wrapper">
        <h2 className="brief_step-title">
          What’s the property address?
        </h2>
        <div className="brief_step-note">
          It's helpful to see the property style and orientation
        </div>
      </div>

      <div className="brief_address-form">
          <div className="brief_address-form-row">
            {!manualInput && (
              <div className="brief_address-form-grid">
                  <div
                    className={cn('brief_address-form-grid-item', {
                      'has-error': (isDirty || invalid) && !isZipValid(value.postcode),
                    })}
                  >
                    <FormInput
                      type='text'
                      inputName="postcode"
                      placeholder="Type post code"
                      className="form-control"
                      value={value.postcode}
                      onChange={postcode => onChange({ ...value, postcode })}
                    />
                  </div>
                <div className={cn('brief_address-form-grid-item -w-1-3')}>
                  <button
                    className={cn('btn -block -shadow')}
                    type='button'
                    onClick={searchPostcode}
                  >
                    Search address
                  </button>
                </div>
              </div>
            )}
          </div>
        { !manualInput && !addressSearchError && addressList.length > 0 && (
          <div className="brief_address-form-row">
            <Suspense fallback={null}>
              <Select
                value={addressSelected}
                options={addressList}
                onChange={onAddressSelected}
                className="custom-select"
                classNamePrefix="react-select"
              />
            </Suspense>
            {/* <ErrorMessage errors={errors} touched={touched} name="firstName" /> */}
          </div>
        )}
          <div className="brief_address-form-row">
            <div className="brief_address-form-manual">
              <Fragment>
                {!manualInput && (
                  <Fragment>
                    {addressSearchError && (
                      <div className="brief_address-form-hint"> Could not find postcode/address</div>
                    )}
                    <div>
                      <button
                        type='button'
                        onClick={()=>setManualInput(!manualInput)}
                        className="btn-link"
                      >
                        Enter manually
                      </button>
                    </div>
                  </Fragment>
                )}
                {manualInput && (
                  <div>
                    <button
                      type='button'
                      onClick={()=>setManualInput(!manualInput)}
                      className="btn-link"
                    >
                      Search address
                    </button>
                  </div>
                )}
              </Fragment>
            </div>
          </div>
        {manualInput && (
          <div className="brief_address-form-row">
            <div className="brief_address-form-grid -vert">
              <div
                className={cn('brief_address-form-grid-item', {
                  'has-error': (isDirty || invalid) && !value.address,
                })}
              >
                {/*<FormInput*/}
                {/*inputName="automatic_address_input"*/}
                {/*type={!manualInput ? 'text' : 'hidden'}*/}
                {/*value={value.address}*/}
                {/*placeholder="Start Typing Address"*/}
                {/*className="form-control"*/}
                {/*onChange={address => onChange({ ...value, address })}*/}
                {/*/>*/}

                {/*<AutocompleteField*/}
                {/*value={value.address}*/}
                {/*list={['ssfsfsf']}*/}
                {/*focused={false}*/}
                {/*onScroll={scrollAddress}*/}
                {/*onBlur={blurAddress}*/}
                {/*onChange={updateAddress}*/}
                {/*onFocus={focusAddress}*/}
                {/*/>*/}
                {/*<ul className="moodboard-select_suggest">{getAutocomplete()}</ul>*/}
                <FormInput
                  inputName="address_input"
                  type={manualInput ? 'text' : 'hidden'}
                  value={value.address}
                  placeholder="Address line"
                  className="form-control"
                  onChange={address => onChange({ ...value, address })}
                />
              </div>

              <div
                className={cn('brief_address-form-grid-item', {
                  'has-error': (isDirty || invalid) && !value.town,
                })}
              >
                <FormInput
                  type={manualInput ? 'text' : 'hidden'}
                  inputName="town_input"
                  placeholder="Town"
                  className="form-control"
                  value={value.town}
                  onChange={town => onChange({ ...value, town })}
                />
              </div>
              <div
                className={cn('brief_address-form-grid-item', {
                  'has-error': (isDirty || invalid) && !isZipValid(value.postcode),
                })}
              >
                <FormInput
                  type='text'
                  inputName="postcode"
                  placeholder="Type post code"
                  className="form-control"
                  value={value.postcode}
                  onChange={postcode => onChange({ ...value, postcode })}
                />
              </div>
            </div>
          </div>
        )}

      </div>


    </div>
  );
};

export default forwardRef(BriefAddress);
// export default BriefAddress;



// WEBPACK FOOTER //
// ./app/javascript/components/brief/components/BriefAddress.js